// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exercise-header {
    padding: 15px;
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: nowrap;

    >h2 {
        color: var(--text-color, #202226);
        font-family: Poppins-bold;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        flex: 1 1;
        min-width: 0;
    }


    >button:hover {
        opacity: .7;
        box-shadow: 0px 5px 10px 0px var(--shadow-color, rgba(234, 240, 246, 0.60));
    }

}

.exercise-header-club-brand {
    margin-left: auto;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    text-decoration: none;
}

.exercise-header-club-logo {
    height: 36px;
    max-width: 120px;
    width: auto;
    object-fit: contain;
}

.exercise-header-club-brand:hover {
    opacity: 0.9;
}


.playerlist {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
    margin: 10px 0;


    img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
    }

    h2 {
        font-size: 16px;
        color: var(--text-color, #202226);
    }
}

.back-btn {
    background-color: var(--surface-color, #fff);
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    height: 30px;
    width: 30px;
    border-radius: 50px;
    border: 1px solid var(--border-color, #EDEDED);
    cursor: pointer;
    color: var(--text-color, #202226);

    img {
        width: 20px
    }
}

.dark-mode .back-btn img {
    filter: invert(1) brightness(1.15);
}

.fav-btn {
    background: none;
}

.input-details {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

.input-detail {
    margin-top: 7px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}

.input-detail > label {
    margin: 5px 0;
    color: var(--text-color, #202226);
    font-family: Poppins;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}

.input-detail > input,
.input-detail > textarea,
.input-detail > select {
    border: 1px solid var(--border-color, transparent);
    border-radius: 8px;
    background-color: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #f4f5f6));
    color: var(--text-color, #404145);
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: 100%;
    box-sizing: border-box;
}

.input-detail > input,
.input-detail > select {
    height: 40px;
    padding: 0 10px;
}

.input-detail > select {
    appearance: none;
    padding-right: 28px;
    background-image: linear-gradient(45deg, transparent 50%, var(--text-secondary, #6b7280) 50%),
      linear-gradient(135deg, var(--text-secondary, #6b7280) 50%, transparent 50%);
    background-position: calc(100% - 14px) calc(50% - 2px), calc(100% - 9px) calc(50% - 2px);
    background-size: 5px 5px, 5px 5px;
    background-repeat: no-repeat;
}

.input-detail > select option {
    background: var(--surface-color, #fff);
    color: var(--text-color, #202226);
}

.input-detail > textarea {
    padding: 10px;
    resize: vertical;
    min-height: 96px;
}

.input-detail > input:focus-visible,
.input-detail > textarea:focus-visible,
.input-detail > select:focus-visible {
    outline: none;
    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.5);
}

.input-detail > button.w-100 {
    margin: 25px auto 8px;
    height: 45px;
    color: #FFF;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border: none;
    border-radius: 8px;
    width: 100%;
    max-width: 280px;
    background-color: var(--brand-primary);
    cursor: pointer;
}

.input-detail > button.w-100:hover {
    opacity: 0.85;
}

/* MUI controls inside group form */
.group-form .MuiOutlinedInput-root,
.group-form .MuiSelect-root,
.add-exercise .MuiOutlinedInput-root {
    background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #fff)) !important;
    color: var(--text-color, #404145) !important;
    border-radius: 8px !important;
    font-family: Poppins !important;
    font-size: 13px !important;
}

.group-form .MuiOutlinedInput-notchedOutline,
.add-exercise .MuiOutlinedInput-notchedOutline {
    border-color: var(--border-color, rgba(0, 0, 0, 0.12)) !important;
}

.group-form .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
.add-exercise .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45) !important;
}

.group-form .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
.add-exercise .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: var(--brand-primary, #0877BC) !important;
}

.group-form .MuiSelect-icon,
.add-exercise .MuiSelect-icon,
.group-form .MuiSvgIcon-root,
.add-exercise .MuiChip-root {
    color: var(--text-secondary, #6b7280);
}

.group-form .MuiChip-root,
.add-exercise .MuiChip-root {
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;
    color: var(--brand-primary, #0877BC) !important;
    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2) !important;
}

.group-form .MuiChip-deleteIcon,
.add-exercise .MuiChip-deleteIcon {
    color: var(--brand-primary, #0877BC) !important;
}

.group-form .MuiButton-outlined,
.add-exercise .MuiButton-outlined {
    color: var(--text-color, #202226) !important;
    border-color: var(--border-color, rgba(0, 0, 0, 0.16)) !important;
    background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color, #fff)) !important;
    justify-content: flex-start !important;
    text-transform: none !important;
    height: 40px !important;
    font-size: 13px !important;
    font-family: Poppins !important;
    border-radius: 8px !important;
}

.group-form .MuiButton-outlined:hover,
.add-exercise .MuiButton-outlined:hover {
    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45) !important;
    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;
}

.group-form__hint {
    padding: 8px 0;
    color: var(--text-secondary, #999);
    font-style: italic;
    font-size: 12px;
}

.group-form__menu-item {
    font-size: 13px !important;
    font-family: Poppins !important;
    border-bottom: 1px solid var(--border-color, #f5f5f5) !important;
    color: var(--text-color, #202226) !important;
}

.MuiMenu-paper.group-form-menu {
    background: var(--surface-color, #fff) !important;
    color: var(--text-color, #202226) !important;
    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
}

.input-radio-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: var(--text-color, #202226);
}

.exercise_notselectted {
    text-align: center;
    color: #ef4444;
    margin: 200px;
}

.input-passwordfield {
    display: flex;
    justify-content: space-between;
    background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #f4f5f6));
    border-radius: 6px;
    padding: 0 10px;
    border: 1px solid var(--border-color, transparent);

    input {
        width: 90%;
        outline: none;
        background: transparent;
        color: var(--text-color, #404145);
    }

    img {
        cursor: pointer;
    }
}

.training_type_list {
    display: flex;
    flex-direction: column;
}

.training_type {
    background-color: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #f4f5f6));
    color: var(--brand-primary);
    outline: none;
    border: none;
    padding: 7px 10px;
    font-size: 15px;
    margin: 5px 0;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;

}

.selected_type {
    border: 1px solid var(--brand-primary);


}

.total-sessions {
    margin-top: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    color: var(--brand-primary);
}

.total-sessions input {
    width: 75%;
}

.addimg_div {
    width: calc(100% - 30px);
    height: 180px;
    margin: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: color-mix(in srgb, var(--text-color) 4%, var(--surface-color, #fff));
    border: 1px dashed var(--border-color, rgba(0, 0, 0, 0.12));
    border-radius: 10px;
    cursor: pointer;

    img {
        width: 40px;
        opacity: 0.75;
    }
}

.dark-mode .addimg_div img {
    filter: invert(1) brightness(1.2);
    opacity: 0.85;
}

.uploaded-picture {
    width: 100%;
    height: 100%;
    max-height: 220px;
    object-fit: cover;
    border-radius: 10px;
    border: 1px solid var(--border-color, transparent);
}


.input_addpicsvg {
    display: none;
}

.changepassword_input {
    margin: 50px 0;
}

/* Page shell for create/edit group */
#adminRoot.group-form-theme {
    color: var(--text-color);
    background-color: var(--bg-color);
    transition: background-color 0.3s ease, color 0.3s ease;
}

#adminRoot.group-form-theme .add-exercise {
    margin-top: 8px;
    margin-bottom: 16px;
}

@media (max-width: 720px) {
    #adminRoot.group-form-theme .add-exercise {
        padding: 16px 14px;
        width: 100%;
        border-radius: 12px;
        box-shadow: none;
        border: none;
        background: transparent;
    }

    .addimg_div {
        width: 100%;
        margin: 0 0 8px;
        height: 140px;
    }

    .uploaded-picture {
        max-height: 180px;
    }

    .input-detail > button.w-100 {
        max-width: 100%;
        margin-top: 18px;
    }
}

/* Shared kind / join-rules fields (also used by EditGroup sheet) */
.group-form .eg-kind-fields,
.group-form .eg-join-rules {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}

.group-form .eg-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.group-form .eg-field > label {
    margin: 5px 0 0;
    color: var(--text-color, #202226);
    font-family: Poppins;
    font-size: 13px;
    font-weight: 600;
}

.group-form .eg-input,
.group-form .eg-select {
    border: 1px solid var(--border-color, transparent);
    border-radius: 8px;
    background-color: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #f4f5f6));
    color: var(--text-color, #404145);
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    width: 100%;
    min-height: 40px;
    padding: 8px 10px;
    box-sizing: border-box;
}

.group-form .eg-hint {
    margin: 0;
    font-size: 12px;
    color: var(--text-secondary, #64748b);
}

.group-form .eg-check {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
    cursor: pointer;
}

.group-form .eg-join-rules__row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 10px;
}

.group-form .eg-join-rules__levels {
    margin: 0;
    padding: 8px 10px;
    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));
    border-radius: 8px;
}

.group-form .eg-join-rules__checks {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 12px;
}

.group-join-rules-block {
    margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/AddGroup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;;IAEjB;QACI,iCAAiC;QACjC,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAO;QACP,YAAY;IAChB;;;IAGA;QACI,WAAW;QACX,2EAA2E;IAC/E;;AAEJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iEAAiE;IACjE,cAAc;;;IAGd;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,iCAAiC;IACrC;AACJ;;AAEA;IACI,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,8CAA8C;IAC9C,eAAe;IACf,iCAAiC;;IAEjC;QACI;IACJ;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;;IAGI,kDAAkD;IAClD,kBAAkB;IAClB,yFAAyF;IACzF,iCAAiC;IACjC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;kFAC8E;IAC9E,wFAAwF;IACxF,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;IACb,8DAA8D;AAClE;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,mCAAmC;AACnC;;;IAGI,2FAA2F;IAC3F,4CAA4C;IAC5C,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;;IAEI,iEAAiE;AACrE;;AAEA;;IAEI,0EAA0E;AAC9E;;AAEA;;IAEI,sDAAsD;AAC1D;;AAEA;;;;IAII,qCAAqC;AACzC;;AAEA;;IAEI,wEAAwE;IACxE,+CAA+C;IAC/C,6EAA6E;AACjF;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;;IAEI,4CAA4C;IAC5C,iEAAiE;IACjE,2FAA2F;IAC3F,sCAAsC;IACtC,+BAA+B;IAC/B,uBAAuB;IACvB,0BAA0B;IAC1B,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;;IAEI,0EAA0E;IAC1E,wEAAwE;AAC5E;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,gEAAgE;IAChE,4CAA4C;AAChD;;AAEA;IACI,iDAAiD;IACjD,4CAA4C;IAC5C,0DAA0D;AAC9D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mFAAmF;IACnF,kBAAkB;IAClB,eAAe;IACf,kDAAkD;;IAElD;QACI,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,iCAAiC;IACrC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yFAAyF;IACzF,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,sCAAsC;;;AAG1C;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sFAAsF;IACtF,2DAA2D;IAC3D,mBAAmB;IACnB,eAAe;;IAEf;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA;IACI,iCAAiC;IACjC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kDAAkD;AACtD;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA,qCAAqC;AACrC;IACI,wBAAwB;IACxB,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA,mEAAmE;AACnE;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,kDAAkD;IAClD,kBAAkB;IAClB,yFAAyF;IACzF,iCAAiC;IACjC,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,0DAA0D;IAC1D,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".exercise-header {\n    padding: 15px;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    flex-wrap: nowrap;\n\n    >h2 {\n        color: var(--text-color, #202226);\n        font-family: Poppins-bold;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        flex: 1;\n        min-width: 0;\n    }\n\n\n    >button:hover {\n        opacity: .7;\n        box-shadow: 0px 5px 10px 0px var(--shadow-color, rgba(234, 240, 246, 0.60));\n    }\n\n}\n\n.exercise-header-club-brand {\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n    text-decoration: none;\n}\n\n.exercise-header-club-logo {\n    height: 36px;\n    max-width: 120px;\n    width: auto;\n    object-fit: contain;\n}\n\n.exercise-header-club-brand:hover {\n    opacity: 0.9;\n}\n\n\n.playerlist {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n    margin: 10px 0;\n\n\n    img {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n    }\n\n    h2 {\n        font-size: 16px;\n        color: var(--text-color, #202226);\n    }\n}\n\n.back-btn {\n    background-color: var(--surface-color, #fff);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    height: 30px;\n    width: 30px;\n    border-radius: 50px;\n    border: 1px solid var(--border-color, #EDEDED);\n    cursor: pointer;\n    color: var(--text-color, #202226);\n\n    img {\n        width: 20px\n    }\n}\n\n.dark-mode .back-btn img {\n    filter: invert(1) brightness(1.15);\n}\n\n.fav-btn {\n    background: none;\n}\n\n.input-details {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    overflow-x: hidden;\n}\n\n.input-detail {\n    margin-top: 7px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n}\n\n.input-detail > label {\n    margin: 5px 0;\n    color: var(--text-color, #202226);\n    font-family: Poppins;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n\n.input-detail > input,\n.input-detail > textarea,\n.input-detail > select {\n    border: 1px solid var(--border-color, transparent);\n    border-radius: 8px;\n    background-color: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #f4f5f6));\n    color: var(--text-color, #404145);\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.input-detail > input,\n.input-detail > select {\n    height: 40px;\n    padding: 0 10px;\n}\n\n.input-detail > select {\n    appearance: none;\n    padding-right: 28px;\n    background-image: linear-gradient(45deg, transparent 50%, var(--text-secondary, #6b7280) 50%),\n      linear-gradient(135deg, var(--text-secondary, #6b7280) 50%, transparent 50%);\n    background-position: calc(100% - 14px) calc(50% - 2px), calc(100% - 9px) calc(50% - 2px);\n    background-size: 5px 5px, 5px 5px;\n    background-repeat: no-repeat;\n}\n\n.input-detail > select option {\n    background: var(--surface-color, #fff);\n    color: var(--text-color, #202226);\n}\n\n.input-detail > textarea {\n    padding: 10px;\n    resize: vertical;\n    min-height: 96px;\n}\n\n.input-detail > input:focus-visible,\n.input-detail > textarea:focus-visible,\n.input-detail > select:focus-visible {\n    outline: none;\n    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.5);\n}\n\n.input-detail > button.w-100 {\n    margin: 25px auto 8px;\n    height: 45px;\n    color: #FFF;\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    border: none;\n    border-radius: 8px;\n    width: 100%;\n    max-width: 280px;\n    background-color: var(--brand-primary);\n    cursor: pointer;\n}\n\n.input-detail > button.w-100:hover {\n    opacity: 0.85;\n}\n\n/* MUI controls inside group form */\n.group-form .MuiOutlinedInput-root,\n.group-form .MuiSelect-root,\n.add-exercise .MuiOutlinedInput-root {\n    background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #fff)) !important;\n    color: var(--text-color, #404145) !important;\n    border-radius: 8px !important;\n    font-family: Poppins !important;\n    font-size: 13px !important;\n}\n\n.group-form .MuiOutlinedInput-notchedOutline,\n.add-exercise .MuiOutlinedInput-notchedOutline {\n    border-color: var(--border-color, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.group-form .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,\n.add-exercise .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45) !important;\n}\n\n.group-form .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,\n.add-exercise .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: var(--brand-primary, #0877BC) !important;\n}\n\n.group-form .MuiSelect-icon,\n.add-exercise .MuiSelect-icon,\n.group-form .MuiSvgIcon-root,\n.add-exercise .MuiChip-root {\n    color: var(--text-secondary, #6b7280);\n}\n\n.group-form .MuiChip-root,\n.add-exercise .MuiChip-root {\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;\n    color: var(--brand-primary, #0877BC) !important;\n    border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2) !important;\n}\n\n.group-form .MuiChip-deleteIcon,\n.add-exercise .MuiChip-deleteIcon {\n    color: var(--brand-primary, #0877BC) !important;\n}\n\n.group-form .MuiButton-outlined,\n.add-exercise .MuiButton-outlined {\n    color: var(--text-color, #202226) !important;\n    border-color: var(--border-color, rgba(0, 0, 0, 0.16)) !important;\n    background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color, #fff)) !important;\n    justify-content: flex-start !important;\n    text-transform: none !important;\n    height: 40px !important;\n    font-size: 13px !important;\n    font-family: Poppins !important;\n    border-radius: 8px !important;\n}\n\n.group-form .MuiButton-outlined:hover,\n.add-exercise .MuiButton-outlined:hover {\n    border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45) !important;\n    background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;\n}\n\n.group-form__hint {\n    padding: 8px 0;\n    color: var(--text-secondary, #999);\n    font-style: italic;\n    font-size: 12px;\n}\n\n.group-form__menu-item {\n    font-size: 13px !important;\n    font-family: Poppins !important;\n    border-bottom: 1px solid var(--border-color, #f5f5f5) !important;\n    color: var(--text-color, #202226) !important;\n}\n\n.MuiMenu-paper.group-form-menu {\n    background: var(--surface-color, #fff) !important;\n    color: var(--text-color, #202226) !important;\n    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n}\n\n.input-radio-btn {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 14px;\n    color: var(--text-color, #202226);\n}\n\n.exercise_notselectted {\n    text-align: center;\n    color: #ef4444;\n    margin: 200px;\n}\n\n.input-passwordfield {\n    display: flex;\n    justify-content: space-between;\n    background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #f4f5f6));\n    border-radius: 6px;\n    padding: 0 10px;\n    border: 1px solid var(--border-color, transparent);\n\n    input {\n        width: 90%;\n        outline: none;\n        background: transparent;\n        color: var(--text-color, #404145);\n    }\n\n    img {\n        cursor: pointer;\n    }\n}\n\n.training_type_list {\n    display: flex;\n    flex-direction: column;\n}\n\n.training_type {\n    background-color: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #f4f5f6));\n    color: var(--brand-primary);\n    outline: none;\n    border: none;\n    padding: 7px 10px;\n    font-size: 15px;\n    margin: 5px 0;\n    border-radius: 5px;\n    cursor: pointer;\n    text-align: center;\n\n}\n\n.selected_type {\n    border: 1px solid var(--brand-primary);\n\n\n}\n\n.total-sessions {\n    margin-top: 8px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 15px;\n    color: var(--brand-primary);\n}\n\n.total-sessions input {\n    width: 75%;\n}\n\n.addimg_div {\n    width: calc(100% - 30px);\n    height: 180px;\n    margin: 15px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: color-mix(in srgb, var(--text-color) 4%, var(--surface-color, #fff));\n    border: 1px dashed var(--border-color, rgba(0, 0, 0, 0.12));\n    border-radius: 10px;\n    cursor: pointer;\n\n    img {\n        width: 40px;\n        opacity: 0.75;\n    }\n}\n\n.dark-mode .addimg_div img {\n    filter: invert(1) brightness(1.2);\n    opacity: 0.85;\n}\n\n.uploaded-picture {\n    width: 100%;\n    height: 100%;\n    max-height: 220px;\n    object-fit: cover;\n    border-radius: 10px;\n    border: 1px solid var(--border-color, transparent);\n}\n\n\n.input_addpicsvg {\n    display: none;\n}\n\n.changepassword_input {\n    margin: 50px 0;\n}\n\n/* Page shell for create/edit group */\n#adminRoot.group-form-theme {\n    color: var(--text-color);\n    background-color: var(--bg-color);\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n#adminRoot.group-form-theme .add-exercise {\n    margin-top: 8px;\n    margin-bottom: 16px;\n}\n\n@media (max-width: 720px) {\n    #adminRoot.group-form-theme .add-exercise {\n        padding: 16px 14px;\n        width: 100%;\n        border-radius: 12px;\n        box-shadow: none;\n        border: none;\n        background: transparent;\n    }\n\n    .addimg_div {\n        width: 100%;\n        margin: 0 0 8px;\n        height: 140px;\n    }\n\n    .uploaded-picture {\n        max-height: 180px;\n    }\n\n    .input-detail > button.w-100 {\n        max-width: 100%;\n        margin-top: 18px;\n    }\n}\n\n/* Shared kind / join-rules fields (also used by EditGroup sheet) */\n.group-form .eg-kind-fields,\n.group-form .eg-join-rules {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n}\n\n.group-form .eg-field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.group-form .eg-field > label {\n    margin: 5px 0 0;\n    color: var(--text-color, #202226);\n    font-family: Poppins;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.group-form .eg-input,\n.group-form .eg-select {\n    border: 1px solid var(--border-color, transparent);\n    border-radius: 8px;\n    background-color: color-mix(in srgb, var(--text-color) 6%, var(--surface-color, #f4f5f6));\n    color: var(--text-color, #404145);\n    font-family: Poppins;\n    font-size: 12px;\n    font-weight: 500;\n    width: 100%;\n    min-height: 40px;\n    padding: 8px 10px;\n    box-sizing: border-box;\n}\n\n.group-form .eg-hint {\n    margin: 0;\n    font-size: 12px;\n    color: var(--text-secondary, #64748b);\n}\n\n.group-form .eg-check {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    font-size: 13px;\n    cursor: pointer;\n}\n\n.group-form .eg-join-rules__row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n    gap: 10px;\n}\n\n.group-form .eg-join-rules__levels {\n    margin: 0;\n    padding: 8px 10px;\n    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.08));\n    border-radius: 8px;\n}\n\n.group-form .eg-join-rules__checks {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 12px;\n}\n\n.group-join-rules-block {\n    margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
